<div class="startup large-page">
  <div *ngIf="editable === false" class="editable-overlay">
    <div class="container">
      <span class="message" style="text-align: left">
        <div style="color: black">Während Deiner Bewerbung kannst Du Deine Daten nicht ändern.</div>
      </span>
    </div>
  </div>
  <div class="container" [class.d-none]="!startup">
    <markant-progress-bar *ngIf="progressBarStatus" indeterminate="" inactive="false"> </markant-progress-bar>
    <app-continuous-action #continuousStartup></app-continuous-action>
    <form [formGroup]="startupForm" [class.d-none]="!startup">
      <div class="row basic-text">
        <div class="col-md-6">
          <div class="headline-text headerText">Logo</div>
          <div class="logo-limiter">
            <div class="logo">
              <div class="stretch">
                <markant-progress-bar *ngIf="progressBarStatus" indeterminate="" inactive="false"> </markant-progress-bar>
                <app-dropzone
                  *ngIf="!logo?.uri"
                  message="Hier kannst Du Dein Logo hochladen"
                  accept=".png"
                  [maxFileSize]="maxFileSize"
                  (fileListChange)="onImageDropped($event)"
                ></app-dropzone>
                <div class="logoActions" *ngIf="logo || transmittedImage">
                  <app-upload-image
                    *ngIf="transmittedImage"
                    (newFileEvent)="changeLogo($event)"
                    [imageType]="this.imageTypeLogo"
                    [height]="400"
                    [width]="400"
                    [expectedMediaTypes]="['image/png']"
                    [transmittedImage]="this.transmittedImage"
                  >
                  </app-upload-image>
                  <markant-icon class="markant-icon" src="assets/svg/m_trash.svg" (click)="deleteLogo()"></markant-icon>
                </div>
                <img *ngIf="logo?.uri" [src]="logo?.uri" alt="" height="400" width="400" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="headline-text headerText">Seiten</div>
          <div class="col-md-12 input seite">
            <markant-input required="false" type="text" label="Website" [pattern]="urlRegex" formControlName="website" class="markant-input" />
          </div>
          <div class="col-md-12 input seite">
            <markant-input type="text" label="Facebook" [pattern]="urlRegex" formControlName="facebook" class="markant-input" />
          </div>
          <div class="col-md-12 input seite">
            <markant-input type="text" label="Twitter" [pattern]="urlRegex" formControlName="twitter" class="markant-input" />
          </div>
          <div class="col-md-12 input seite">
            <markant-input type="text" label="Instagram" [pattern]="urlRegex" formControlName="instagram" class="markant-input" />
          </div>
          <div hidden class="col-md-12 input seite">
            <markant-input type="text" label="Warenbereich" formControlName="group" class="markant-input" />
          </div>
          <div class="col-md-12 input seite">
            <markant-input type="number" label="Gründungsjahr" formControlName="founded" required class="markant-input" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="headline-text headerText">Beschreibung</div>
          <div class="basic-text" id="descriptionContainer">
            <markant-textarea
              label="Beschreibung Ihres Unternehmens"
              show-character-counter="true"
              autogrow="true"
              maxlength="2500"
              required
              formControlName="description"
              ngDefaultControl
              class="u-full-width basic-text textarea"
              placeholder="{{ STARTUP_DESC_LABEL }}"
              id="startupDescription"
              style="margin-top: 15px"
            ></markant-textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="headline-text headerText">Adresse</div>
          <div>
            <div class="row" style="flex-wrap: nowrap">
              <div class="seite two-third">
                <markant-input [readonly]="true" formControlName="street" label="Straße" id="input-street" />
                <markant-tooltip for="input-street" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
              </div>
              <div class="col-md-4 seite one-third">
                <markant-input [readonly]="true" formControlName="zip" label="PLZ" id="input-zip" />
                <markant-tooltip for="input-zip" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
              </div>
            </div>
            <div class="col-md-12 seite">
              <markant-input [readonly]="true" formControlName="city" label="Stadt" id="input-city" />
              <markant-tooltip for="input-city" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
            </div>
          </div>
          <div class="col-md-13 seite">
            <markant-select [readonly]="true" formControlName="countryIso2Code" label="Land" id="select-country">
              <markant-select-option value="{{ c }}" *ngFor="let c of countries" [value]="c.iso">{{ c.nameDe }}</markant-select-option>
            </markant-select>
            <markant-tooltip for="select-country" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
          </div>
        </div>
        <div class="col-md-6" formGroupName="contact">
          <div class="headline-text headerText">Kontakt</div>
          <div class="row">
            <div class="col-md-3 seite one-third">
              <markant-select [readonly]="true" formControlName="title" label="Anrede" id="select-title">
                <markant-select-option [value]="Title.FEMALE">Frau</markant-select-option>
                <markant-select-option [value]="Title.MALE">Herr</markant-select-option>
                <markant-select-option [value]="Title.DIVERSE">Divers</markant-select-option>
              </markant-select>
              <markant-tooltip for="select-title" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
            </div>

            <div class="col-md-4 seite one-third">
              <markant-input [readonly]="true" formControlName="firstName" label="Vorname" id="input-firstName" />
              <markant-tooltip for="input-firstName" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
            </div>

            <div class="col-md-4 seite one-third">
              <markant-input [readonly]="true" formControlName="lastName" label="Nachname" id="input-lastName" />
              <markant-tooltip for="input-lastName" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
            </div>
          </div>

          <div class="seite">
            <markant-input
              [readonly]="true"
              formControlName="email"
              label="E-Mail"
              helper="An diese Adresse senden wir dir Informationen zum Pitch."
              helper-persistent="true"
              id="input-email"
            />
            <markant-tooltip for="input-email" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
          </div>

          <div class="seite">
            <markant-input [readonly]="true" formControlName="phone" label="Telefon" id="input-phone" />
            <markant-tooltip for="input-phone" [label]="PLEASE_CONTACT_MARKANT_LABEL" />
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
